<template>
  <el-card>
    <el-form class="" label-width="120px" label-position="right">
      <el-form-item label="预约项目名称：" prop="itemName">
        {{ formData.itemName }}
      </el-form-item>
      <el-form-item label="所属公园：" prop="projectName">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item label="项目图片：" prop="itemImg">
        <template v-if="formData.itemImg">
          <el-image class="img" :src="formData.itemImg.filePrefix + formData.itemImg.fileUrl"
            :preview-src-list="[formData.itemImg.filePrefix + formData.itemImg.fileUrl]" fit="fill">
          </el-image>
        </template>
      </el-form-item>

      <div class="table">
        <el-table class="global-table mb20 dlg-table" max-height="400" :data="formData.appointItemTimeList" ref="table">
          <el-table-column label="预约入园时间段" prop="workerendTimeIdList" min-width="400" align='center'
            showOverflowTooltip>
            <template v-slot="{ row }">
              <div>{{ row.startTime }} - {{ row.endTime }}</div>
            </template>
          </el-table-column>
          <el-table-column label="预约人数上限" prop="limitNum" min-width="220" align='center'
            showOverflowTooltip></el-table-column>
        </el-table>
      </div>

      <el-form-item label="开启状态：" prop="itemStatus">
        {{ formData.itemStatus === '1' ? '已开启' : '已关闭' }}
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'ProjectDetail',
  data() {
    return {
      formData: {
        projectId: '',
        itemName: '',
        appointItemTimeList: [],
        itemImg: null
      }
    }
  },
  computed: {
    itemId() {
      return this.$route.params.id
    }
  },
  created() {
    if (this.itemId) {
      this.loadData()
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.tourist.selectAppointItemByItemId, {
        itemId: this.itemId
      }).then(res => {
        console.log(res, '详情')
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">
.img {
  width: 104px;
  height: 104px;
  line-height: 104px;
}
</style>
